import { FundingComputedDto } from '@src/data/types/FundingComputedDto'
import { FundingInfoDto } from '@src/data/types/FundingInfoDto'
import {
  EditIfXpressWorksheetDto,
  IfXpressWorksheet,
  IfXpressWorksheetDecisionDTO,
  IfXpressWorksheetRevision,
} from '@src/data/types/IfXpressWorksheetSchema'
import allApi from '../../api'
import { makeGetById, makeGetListWithIds, makeSave } from '../effects/standard-side-effects'
import {
  COMPUTE_IFXPRESS_FUNDING,
  GET_IFXPRESS_WORKSHEET_BY_ID,
  GET_IFXPRESS_WORKSHEET_REVISIONS,
  IfXpressWorksheetSlice,
  SAVE_IFXPRESS_WORKSHEET,
  SAVE_IFXPRESS_WORKSHEET_DECISION,
} from './ifxpress-worksheet-store'

const ifXpressWorksheetEffects = {
  create: (data: EditIfXpressWorksheetDto) =>
    makeSave<EditIfXpressWorksheetDto, IfXpressWorksheet>(
      SAVE_IFXPRESS_WORKSHEET,
      allApi.ifxpressWorksheet.create,
      IfXpressWorksheetSlice.actions.setCurrent,
      data,
    ),
  update: (data: EditIfXpressWorksheetDto) =>
    makeSave<EditIfXpressWorksheetDto, IfXpressWorksheet>(
      SAVE_IFXPRESS_WORKSHEET,
      allApi.ifxpressWorksheet.update,
      IfXpressWorksheetSlice.actions.setCurrent,
      data,
    ),

  computeIfXpressFunding: (data: FundingInfoDto) =>
    makeSave<FundingInfoDto, FundingComputedDto>(
      COMPUTE_IFXPRESS_FUNDING,
      allApi.ifxpressWorksheet.computeIfXpressFunding,
      IfXpressWorksheetSlice.actions.setFundingComputed,
      data,
    ),
  getWorksheetRevisions: (creditApplicationId: string) =>
    makeGetListWithIds<IfXpressWorksheetRevision>(
      GET_IFXPRESS_WORKSHEET_REVISIONS,
      allApi.ifxpressWorksheet.getWorksheetRevisions,
      IfXpressWorksheetSlice.actions.setCurrentRevisions,
      { creditApplicationId },
    ),
  updateDecision: (data: IfXpressWorksheetDecisionDTO) =>
    makeSave<IfXpressWorksheetDecisionDTO, IfXpressWorksheet>(
      SAVE_IFXPRESS_WORKSHEET_DECISION,
      allApi.ifxpressWorksheet.updateDecision,
      IfXpressWorksheetSlice.actions.setCurrent,
      data,
    ),
  getById: (creditApplicationId: string) =>
    makeGetById<IfXpressWorksheet>(
      GET_IFXPRESS_WORKSHEET_BY_ID,
      allApi.ifxpressWorksheet.getById,
      IfXpressWorksheetSlice.actions.setCurrent,
      {
        creditApplicationId,
      },
    ),
}

export default ifXpressWorksheetEffects
